/*! hash:06b0d4e8a9e4ea1bc02d, chunkhash:85b17905197195b8bc28, name:sass/index, filebase:index.85b179051.js, query:, file:static/js/sass/index.85b179051.js */
webpackJsonp([4],{

/***/ 15:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__(1);

__webpack_require__(15);

var _global = __webpack_require__(2);

$(function () {
  $(window).resize(function () {
    toggleDom();
    Affix();
  });
  toggleDom();
  Affix();
  wayPoint();
  $(".section .mode-list .mode-item").hover(function () {
    $(this).addClass("active").siblings().removeClass("active");
  });
  mouseXqcList();
  // $('.btn-wrapper').find('.btn2').click(function() {
  //   window.open(vUrl)z
  // })
});
function wayPoint() {
  $('.page').waypoint(function (direction) {
    if (direction === 'down') {
      $(this.element).find('.state').addClass('animated slideInUp');
      $(this.element).find('.stateRight').addClass('animated fadeInRight');
    }
  }, { offset: '70%' });
}

function toggleDom() {
  var windowWidth = $(window).width();
  if (windowWidth <= 768) {
    $('#ourAdv1').hide();
    $('#ourAdv2').show();
    $('#model1').hide();
    $('#model2').show();
  } else {
    $('#ourAdv1').show();
    $('#ourAdv2').hide();
    $('#model1').show();
    $('#model2').hide();
  }
}

function Affix() {
  var navTop = $('#navTop').offset().top;
  $("#affixBox").affix({
    offset: {
      top: navTop
    }
  });
}

function mouseXqcList() {
  $("#xqc li").mouseenter(function () {
    var index = $(this).index() + 1;
    $("#xqcImg").attr("src", '../../static/img/sass/xqc' + index + '.png');
  });
  $("#pro li").mouseenter(function () {
    var index = $(this).index() + 1;
    $("#proImg").attr("src", '../../static/img/sass/pro' + index + '.png');
  });
  $("#qx li").mouseenter(function () {
    var index = $(this).index() + 1;
    $("#qxImg").attr("src", '../../static/img/sass/qx' + index + '.png');
  });
  $("#wechat li").mouseenter(function () {
    var index = $(this).index() + 1;
    $("#wechatImg").attr("src", '../../static/img/sass/wechat' + index + '.png');
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })

},[31]);


// WEBPACK FOOTER //
// static/js/sass/index.85b179051.js